import * as React from 'react';
import * as styles from './styles.css';
import { ITabProps, Tabs } from '@cian/ui-kit/prev';
import { Layout } from '../../../../components/Layout';

interface IClustersLayoutProps {
  title: React.ReactNode;
  tabs: ITabProps[];
  activeTab: string;
  onTabChange: (newTab: string) => void;
  tabContent: React.ReactNode;
}

export function ClustersLayout({ title, activeTab, tabContent, onTabChange, tabs }: IClustersLayoutProps) {
  return (
    <section className={styles['container']} id="clusters">
      <Layout>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['tabs']}>
            <Tabs tabs={tabs} onChange={onTabChange} activeTab={activeTab} />
          </div>
          {tabContent}
        </div>
      </Layout>
    </section>
  );
}
